import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IDevelopmentState {
    isDevelopmentMode: boolean;
}

const initialState: IDevelopmentState = {
    isDevelopmentMode: false,
};

export const developmentSlice = createSlice({
    name: 'development',
    initialState,
    reducers: {
        setterDevelopment: (state, action: PayloadAction<Partial<IDevelopmentState>>) => ({
            ...state,
            ...action.payload,
        }),
    },
});

export const { setterDevelopment } = developmentSlice.actions;

export default developmentSlice.reducer;
